import { useEffect, useState } from 'react';
import { azureFileUploadManager, FileUploadItem } from '../azureFileUploadManager';

interface AzureFileUploadOptions {
  onUploadComplete?: (id: string) => void;
  /** Fired when the blob upload fails. Not fired when the upload was cancelled by the caller. */
  onUploadError?: (id: string, error: Error) => void;
  // onProgress?: (id: string, progress: number) => void;
}

export const useAzureFileUpload = (options: AzureFileUploadOptions = {}) => {
  const [uploads, setUploads] = useState<FileUploadItem[]>(() => azureFileUploadManager.getAll());

  useEffect(() => {
    const callback = (list: FileUploadItem[]) => setUploads([...list]);
    azureFileUploadManager.subscribeList(callback);
    return () => azureFileUploadManager.unsubscribeList(callback);
  }, []);

  const uploadFile = (id: string, file: File, path: string, token: string) => {
    azureFileUploadManager.uploadFile(id, file, path, token, options);
  };
  const downloadFile = (documentName: string, downloadPath: string, downloadToken: string, target?: string) =>
    azureFileUploadManager.downloadFile(documentName, downloadPath, downloadToken, target);
  const cancelUpload = (uploadId: string) => azureFileUploadManager.cancelUpload(uploadId);
  const deleteUpload = (uploadId: string) => azureFileUploadManager.deleteUpload(uploadId);
  const deleteFile = (uploadId: string) => azureFileUploadManager.deleteFile(uploadId);

  return { uploadList: uploads, uploadFile, downloadFile, cancelUpload, deleteUpload, deleteFile };
};
